import { gql } from '@apollo/client'

export default gql`
  query GetClinician($name: String) {
    getEligibleConsultants(name: $name) {
      id
      name
    }
  }
`
